import { push } from 'react-router-redux';
import update from 'immutability-helper';
import Notifications from 'react-notification-system-redux';

import { authLoginUserFailure } from '../../../actions/auth';
import { checkHttpStatus, parseJSON } from '../../../utils';
import {
   fetchCommissions,
   patchCommission,
 } from '../../../core/api';
// ------------------------------------
// Constants
// ------------------------------------
export const COMMISSION_FETCH_FAILURE = 'COMMISSION_FETCH_FAILURE';
export const COMMISSION_FETCH_REQUEST = 'COMMISSION_FETCH_REQUEST';
export const COMMISSION_FETCH_SUCCESS = 'COMMISSION_FETCH_SUCCESS';
export const COMMISSION_EDIT_FAILURE = 'COMMISSION_EDIT_FAILURE';
export const COMMISSION_EDIT_REQUEST = 'COMMISSION_EDIT_REQUEST';
export const COMMISSION_EDIT_SUCCESS = 'COMMISSION_EDIT_SUCCESS';
// ------------------------------------
// Actions
// ------------------------------------

function findByBidId(value) {
  return value.bid.id === this;
}

export function commissionFetchRequest() {
  return {
    type: COMMISSION_FETCH_REQUEST,
    payload: null,
  };
}
export function commissionFetchSuccess(json) {
  return {
    type: COMMISSION_FETCH_SUCCESS,
    payload: json.results,
  };
}
export function commissionFetchFailure(json) {
  return {
    type: COMMISSION_FETCH_FAILURE,
    payload: json,
  };
}
export function commissionEditRequest() {
  return {
    type: COMMISSION_EDIT_REQUEST,
    payload: null,
  };
}
export function commissionEditSuccess(json) {
  return {
    type: COMMISSION_EDIT_SUCCESS,
    payload: json,
  };
}
export function commissionEditFailure(json) {
  return {
    type: COMMISSION_EDIT_FAILURE,
    payload: json,
  };
}

export function editCommission(id, payload) {
  return (dispatch) => {
    dispatch(commissionEditRequest(payload));
    return patchCommission(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(commissionEditSuccess(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              dispatch(commissionEditFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
              // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(editCommission(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(editCommission(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(commissionEditFailure(payload));
      });
  };
}

export function requestCommission() {
  return (dispatch) => {
    dispatch(commissionFetchRequest());
    return fetchCommissions()
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(commissionFetchSuccess(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
              dispatch(commissionEditFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
              // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(requestCommission()),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(requestCommission()),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(commissionFetchFailure());
      });
  };
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [COMMISSION_FETCH_REQUEST]: (state, action) => {
    return update(
      state,
      {
        $merge:
        {
          needFetch: false,
          isFetching: true,
        },
      },
    );
  },
  [COMMISSION_FETCH_SUCCESS]: (state, action) => {
    return update(
      state,
      {
        $merge:
        {
          isFetching: false,
          commissions: action.payload,
        },
      },
    );
  },
  [COMMISSION_EDIT_SUCCESS]: (state, action) => {
    const id = action.payload.bid.id;

    const commissions = state.commissions;
    const idx = commissions.findIndex(findByBidId, id);
    let newState;
    // Update bids
    if (idx === -1) {
      newState = update(state,
        { commissions:
              { $push: [action.payload] },
        });
    } else {
      newState = update(state,
        { commissions:
        { [idx]:
              { $set: action.payload },
        },
        });
    }
    return newState;
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  isFetching: false,
  needFetch: true,
  hasError: false,
  commissions: [],
};

export default function registerReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// src/routes/commissions/modules/commission.js